import React, { createContext, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { InsightsProgressFilterModal } from "../components/v2/insights/Summary/componentUtils/InsightsProgressFilterModal";
import { FilterObj, OverallProgressFilterObj } from "../types";

export const InsightsProgressFilterContext = createContext({});

export const InsightsProgressFilterProvider: React.FC = ({ children }) => {
  const location = useLocation();
  const [filters, setFilters] = React.useState<OverallProgressFilterObj[]>([]);
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [, setCurrentTab] = React.useState(
    Number(new URLSearchParams(location.search).get("tab")) ?? 0
  );
  const [selectedCourseFilter, setSelectedCourseFilter] = React.useState<{
    moduleIds?: string[];
    targetIds?: string[];
  } | null>(null);

  const [selectedDateFilter, setSelectedDateFilter] = React.useState<
    FilterObj | undefined
  >(undefined);

  // hide learning targets filter options on hints/errors page
  // update filter to remove targets if present
  const removeTargetFilters = useCallback(() => {
    const currentTab = Number(new URLSearchParams(location.search).get("tab")) ?? 0;
    const targetFilters = [...filters].filter((item) => item.type === "target");

    if (currentTab === 2 && targetFilters.length) {
      const newFilters = [...filters].filter((item) => item.type === "module");
      setFilters(newFilters);
    }
    setCurrentTab(currentTab);
  }, [filters, location.search]);

  useEffect(() => {
    const currentTab = Number(new URLSearchParams(location.search).get("tab")) ?? 0;
    if (currentTab === 2) {
      removeTargetFilters();
    }
  }, [location.search, removeTargetFilters]);

  useEffect(() => {
    // if (!courseStructureCtx.courseTreeStructure) return;

    const targetFilters = filters
      .filter((filter: OverallProgressFilterObj) => filter.type === "target")
      .map((filter: OverallProgressFilterObj) => filter.id);

    let moduleFilters = filters
      .filter((filter: OverallProgressFilterObj) => filter.type === "module")
      .map((filter: OverallProgressFilterObj) => filter.id);

    // Temporary logic as per original function, defaults to all module IDs in the course if no filters are set
    // if (moduleFilters.length < 1 && targetFilters.length < 1) {
    //   moduleFilters =
    //     courseStructureCtx.courseTreeStructure?.getAllModuleIdsInCourse() || [];
    // }
    if (targetFilters.length < 1 && moduleFilters.length < 1) {
      setSelectedCourseFilter(null);
    } else {
      // Update state with the new filters
      setSelectedCourseFilter({
        ...(moduleFilters.length && { moduleIds: moduleFilters }),
        ...(targetFilters.length && { targetIds: targetFilters }),
      });
    }
  }, [filters]); // courseStructureCtx.courseTreeStructure]);

  return (
    <InsightsProgressFilterContext.Provider
      value={{
        filters,
        setFilters,
        filterModalOpen,
        setFilterModalOpen,
        selectedCourseFilter,
        selectedDateFilter,
        setSelectedDateFilter,
      }}>
      {children}
      <InsightsProgressFilterModal
        open={filterModalOpen}
        handleClose={() => setFilterModalOpen(false)}
      />
    </InsightsProgressFilterContext.Provider>
  );
};
